import React, { useState } from "react";
import Banner from "./../Banner/Banner";
import Header from "./../../Components/Header";
import Footer from "./../../Components/Footer";
import "./contact.scss";
import Map from "../../Components/GoogleMap/map";
import { db } from "./../../Config/Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

toast.configure();

const contactCard = [
  {
    icon: "fas fa-map-marker-alt",
    title: "Address",
    details: "Budhanilkantha-10,Kapan ",
    details1: "Kathmandu, Nepal",
  },
  {
    icon: "fas fa-phone",
    title: "Phone",
    details: "+9779802432571",
    details1: "01-525453",
  },
  {
    icon: "fas fa-envelope",
    title: "Email",
    details: "support@gmail.com",
    details1: "stopshop@gmail.com",
  },
];

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const Query = (e) => {
    e.preventDefault();

    db.collection("contact_form")
      .doc("Query")
      .set({
        Name: name,
        Email: email,
        Subject: subject,
        Message: message,
      })
      .then(() => {
        toast.info("Query is taken in account you will be notified soon", {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
      });
  };

  return (
    <>
      <Header />
      <Banner title={"Contact us"} />
      <div className="section contact">
        <div className="container">
          <h4 className="text-center mb-4">WE ARE HERE!</h4>

          <div className="row" data-aos="fade-up">
            <Map />
          </div>

          <div className="row my-5">
            {contactCard.map((cardDetails) => (
              <div
                className="col-lg-4 col-md-4 col-sm-12 col-xs-12"
                data-aos="fade-up"
              >
                <div className="contact">
                  <div className="contact_card">
                    <i
                      className={cardDetails.icon}
                      style={{ color: "#ff7b54", marginBottom: "10px" }}
                    ></i>
                    <div className="contact_card_text">
                      <h4 className="mb-2">{cardDetails.title}</h4>
                      <p>
                        {cardDetails.details} <br /> {cardDetails.details1}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row my-5">
            <div
              className="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
              data-aos="fade-up"
            >
              <h3 className="text-center mb-4">Contact Form</h3>
              <form className="contact_form" onSubmit={Query}>
                <div className="mb-3">
                  {/* <label htmlFor="email">Name</label> */}
                  <input
                    placeholder="Name..."
                    type="text"
                    className="form-control"
                    required
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                    value={name}
                  />
                </div>
                <div className="mb-3">
                  {/* <label htmlFor="email">Email</label> */}
                  <input
                    placeholder="Email..."
                    type="email"
                    className="form-control"
                    required
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    value={email}
                  />
                </div>

                <div className="mb-3">
                  <input
                    placeholder="Subject..."
                    type="text"
                    className="form-control"
                    required
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                    value={subject}
                  />
                </div>
                <div className="mb-3">
                  <textarea
                    placeholder="Message..."
                    type="text"
                    className="form-control"
                    rows="5"
                    required
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                    value={message}
                  />
                </div>

                <button type="submit" className="btn btn-success btn-block">
                  SUBMIT YOUR QUERY
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
